import React, {useContext, useEffect, useRef} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import BodySwipable from "../../visComponents/navigation/desktop/bodySwipable";
import MaterialsWizardFooterStep from "./materialsWizardFooterStep";
import {
  getWizardStepIsDisabled
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {wizardItemInterface} from "../../../interfaces/wizardItemInterface";
import MaterialsWizardContext from "./MaterialsWizardContext";

// const stepWidth = 92;
const MaterialsWizardFooterSteps = (props) => {

  const {wizardItem, wizardSelectedValues, wizardActiveStep, isShoppingCart, showAdvancedQuoting} = props;

  const scrollElementRef = useRef();
  const wizContext = useContext(MaterialsWizardContext);

  // const stepWidth = isMobile ? 92 : 92;

  const {wizardSteps} = wizContext;
  // console.log("wizardSteps", wizardSteps);

  // Auto-center the active step whenever it changes (custom 500ms ease-in-out)
  useEffect(() => {
    const container = scrollElementRef.current;
    if (!container) return;

    const activeEl = container.querySelector(`[data-step="${wizardActiveStep}"]`);
    if (!activeEl) return;

    // Clamp so we never try to scroll past the start or end of the list.
    // Without this the animation target is out-of-range and the container
    // jumps to the boundary instead of gliding to it.
    const raw = activeEl.offsetLeft - container.clientWidth / 2 + activeEl.offsetWidth / 2;
    const target = Math.max(0, Math.min(raw, container.scrollWidth - container.clientWidth));

    const start = container.scrollLeft;
    const distance = target - start;
    if (Math.abs(distance) < 1) return;           // already there, skip

    const DURATION = 500; // ms
    const ease = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; // ease-in-out

    const startTime = performance.now();
    let raf;
    let cancelled = false;

    // Expose a cancel hook so bodySwipable can interrupt when the user drags
    container._cancelAutoScroll = () => { cancelled = true; };

    const tick = (now) => {
      if (cancelled) return;
      const progress = Math.min((now - startTime) / DURATION, 1);
      container.scrollLeft = start + distance * ease(progress);
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        container._cancelAutoScroll = null;
      }
    };

    raf = requestAnimationFrame(tick);

    // Cleanup: if wizardActiveStep changes again mid-flight, cancel the old animation
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
      container._cancelAutoScroll = null;
    };
  }, [wizardActiveStep]);

  // const styles = {
  //   width: (wizardSteps.length + (isShoppingCart ? 1 : 0)) * stepWidth
  // }

  // const currentGroups = getCurrentGroups(wizardItem, wizardActiveStep, wizardSelectedValues);
  // const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;
  // const menuWidth = windowWidth * 35 / 100; // 35% of screen
  // const useContainerOverFlow = styles.width >menuWidth;

  const content = (
    <div className="selection-footer-list"
         ref={scrollElementRef}
      // ref={footerList}
    >
      {wizardSteps.map((step) => {
        const stepDisabled = getWizardStepIsDisabled(step.stepIndex, wizardSelectedValues, wizardSteps);
        if (showAdvancedQuoting && (step.stepIndex !== wizardActiveStep) && window.location.href.includes("materials")) {
          return null
        }
        return <MaterialsWizardFooterStep wizardSelectedValue={wizardSelectedValues[step.stepIndex]}
                                          wizardItem={wizardItem}
                                          isShoppingCart={isShoppingCart}
                                          stepDisabled={stepDisabled}
                                          stepGroups={step.stepGroups}
                                          stepIndex={step.stepIndex}
                                          key={"wizValue" + step.stepIndex}/>
      })}
    </div>
  )

  // return useContainerOverFlow ? (
  //   <BodySwipable className="selection-footer-cell" scrollableSelector={".selection-footer-list"}>
  //     {/*<div className="selection-footer-cell__shadow selection-footer-cell__shadow--left"*/}
  //     {/*     style={{ left: this.state.shadowLeft }}/>*/}
  //     {content}
  //   </BodySwipable>
  // ) : <div className="selection-footer-cell">{content}</div>

  return (
    <BodySwipable className="selection-footer-cell" scrollableSelector={".selection-footer-list"} scrollableRef={scrollElementRef}>
      {content}
    </BodySwipable>
  )

};

MaterialsWizardFooterSteps.propTypes = {
  isShoppingCart: PropTypes.bool,
  wizardItem: PropTypes.shape(wizardItemInterface).isRequired,
  wizardValues: PropTypes.object,
  wizardStep: PropTypes.number,
}

const mapStateToProps = (store, ownProps) => {
  const {wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {windowWidth, isMobile} = store.serverState;
  const {wizardValues} = ownProps;
  const {showAdvancedQuoting} = store.advancedQuotingState;

  return {
    wizardSelectedValues: wizardValues || wizardSelectedValues,
    wizardActiveStep,
    // wizardActiveStep: Number.isInteger(wizardStep) ? wizardStep : wizardActiveStep,
    windowWidth,
    isMobile,
    showAdvancedQuoting,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsWizardFooterSteps)
